import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { Button } from "@my-scoot/component-library-legacy";
import VisibilityIcon from "@material-ui/icons/Visibility";
import CheckIcon from "@material-ui/icons/CheckCircleOutline";

import { useSelector } from "react-redux";
import { is_empty } from "utils/validations";

const Footer = (props) => {
  useEffect(() => {
    const updateSidebarWidth = () => {
      const sidebarWidth =
        document.querySelector("#webpageBuilder-sidebar-root")?.offsetWidth ||
        400;

      const root = document.querySelector(":root");
      root.style.setProperty("--sidebar-width", `${sidebarWidth}px`);
    };

    updateSidebarWidth();

    window.addEventListener("resize", updateSidebarWidth);
    return () => {
      window.removeEventListener("resize", updateSidebarWidth);
    };
  }, []);

  const { handleSave, handlePreview, isSaving, disableAllEdits } = props;

  const save_cta_text = useSelector(
    (state) => state.webpage_detail.save_cta_text
  );
  const handleSaveCta = useSelector(
    (state) => state.webpage_detail.handleSaveCta
  );

  return (
    <div className="tw-fixed tw-bottom-0 tw-left-0 tw-w-full tw-bg-[#fffc] tw-backdrop-blur-[4px] tw-p-[15px] tw-z-[2000] tw-border tw-border-[#e4e8f0] tw-shadow-[0_-1px_2px_1px_#0001] tw-grid tw-grid-cols-2 tw-gap-[15px] min-[780px]:tw-w-[var(--sidebar-width,560px)]">
      <Button
        variant="outlined"
        color="primary"
        disableElevation
        disabled={isSaving}
        onClick={() => handlePreview()}
        className="tw-w-full tw-h-[40px] !tw-normal-case !tw-tracking-normal tw-font-semibold !tw-text-[#3f51b5] !tw-bg-white !tw-border-2 !tw-border-[#3f51b5] !tw-rounded-[6px] !tw-flex tw-items-center tw-justify-center hover:tw-bg-black/5"
      >
        Preview&nbsp;
        <VisibilityIcon className="tw-ml-[5px] tw-text-[22px]" />
      </Button>
      <Button
        variant="contained"
        color="primary"
        disableElevation
        disabled={isSaving || disableAllEdits}
        loading={isSaving}
        onClick={() => {
          handleSaveCta
            ? handleSaveCta()
            : handleSave("Webpage Saved Successfully!");
        }}
        className="tw-w-full tw-h-[40px] !tw-normal-case !tw-tracking-normal tw-font-semibold !tw-rounded-[6px] !tw-flex tw-items-center tw-justify-center"
      >
        {is_empty(save_cta_text) ? "Update" : save_cta_text}&nbsp;
        <CheckIcon className="tw-ml-[5px] tw-text-[22px]" />
      </Button>
    </div>
  );
};

Footer.propTypes = {
  handleSave: PropTypes.func,
  handlePreview: PropTypes.func,
};

export { Footer };
